import APICall from '../utils/APICall';

export default class  DepositServices {
  
    static listDeposits = async (page, pageLimit, search, from, to,depositStatus) => {
        return await APICall(`/api/Deposit/admin/list-deposits?page=${page}&pageLimimt=${pageLimit}&search=${search}&from=${from}&to=${to}&depositStatus=${depositStatus}`, "GET");
    }
    static viewDeposit = async (username) => {
        return await APICall(`/api/Deposit/admin/view-deposit?username=${username}`, "POST");
    }
    static exportDeposit = async (search, from, to, depositStatus) => {
        return await APICall(`/api/Deposit/admin/export-deposit?search=${search}&from=${from}&to=${to}&depositStatus=${depositStatus}`, "GET")
    }
}

